<template>
    <PatientRowCells :patient="patient" class="table-tr" :class="{ inactive: patient.current_month > 6 }" :showDaysTillEndOfSubscription="showDaysTillEndOfSubscription">
        <span :id="`patient-${patient.id}`" class="patient-anchor"></span>

        <div class="table-td cell-length">
            <a :href="`/pacient/${patient.id}`">
                <PatientUserImage :patient="patient" />

                <div class="patient-info">
                    <span class="user-name">
                        <strong>{{ patient.user | fullname }}</strong>
                        {{ patient.age }}
                    </span>
                    
                    <PatientProgress :patient="patient" />
                </div>
            </a>
        </div>
    </PatientRowCells>
</template>

<script>
import PatientRowCells from './PatientRowCells'
import PatientUserImage from '@components/PatientsMatrix/Cells/PatientUserImage'

export default {
    components: {
        PatientUserImage,
        PatientRowCells
    },
    props: {
        patient: {
            type: Object,
            required: true
        },
        showDaysTillEndOfSubscription: {
            type: Boolean,
            required: false
        }
    }
}
</script>
